import type { video } from "./client";

/**
 * Frontend effect names (used in UI components)
 */
export type FrontendEffect =
  | "zoom-in"
  | "zoom-out"
  | "pan-left"
  | "pan-right";

/**
 * Maps frontend effect names to backend MotionType values
 */
export const effectToMotion: Record<FrontendEffect, video.MotionType> = {
  "zoom-in": "zoom_in",
  "zoom-out": "zoom_out",
  "pan-left": "pan_left",
  "pan-right": "pan_right",
};

/**
 * Maps backend MotionType values to frontend effect names
 */
export const motionToEffect: Record<video.MotionType, FrontendEffect> = {
  auto: "zoom-in", // Default to zoom-in for auto
  zoom_in: "zoom-in",
  zoom_out: "zoom-out",
  pan: "pan-left", // Map generic pan to pan-left
  pan_left: "pan-left",
  pan_right: "pan-right",
};

/**
 * Converts a frontend effect to backend motion type
 */
export function toMotionType(effect: FrontendEffect): video.MotionType {
  return effectToMotion[effect];
}

/**
 * Converts a backend motion type to frontend effect
 */
export function toFrontendEffect(motion: video.MotionType): FrontendEffect {
  return motionToEffect[motion];
}
